<div class="station-card-hover text-white" (click)="onEventClick()">
    <mat-icon>{{icon}}</mat-icon>
    <span class="information">{{label}}</span>
</div>